import { Link, useLocation } from 'react-router-dom'
import './TopNav.css'

export default function TopNav() {
  const { pathname } = useLocation()
  const isIndex = pathname === '/'
  const articlesIsActive = pathname === '/articles' || pathname.startsWith('/articles/')

  return (
    <header className="top-nav">
      <div className="top-nav__inner">
        <a href="/" className="top-nav__logo" aria-label="Contrast Shower home">
          <img src="/images/logo-small.png" alt="Contrast Shower" className="top-nav__logo-img" />
        </a>

        <div className="top-nav__right">
          <nav className="top-nav__links">
            {isIndex ? (
              <>
                <a href="#testimonials" className="top-nav__link">Reviews</a>
                <a href="#plus" className="top-nav__link">Benefits</a>
                <a href="#features" className="top-nav__link">Features</a>
              </>
            ) : (
              <a href="/" className="top-nav__link">How to Contrast</a>
            )}
            <Link
              to="/articles"
              className={`top-nav__link${articlesIsActive ? ' top-nav__link--active' : ''}`}
            >
              Blog
            </Link>
          </nav>

          <a href="/" className="top-nav__cta">
            Get the App
          </a>
        </div>
      </div>
    </header>
  )
}
